import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  const [activeCategory, setActiveCategory] = useState<string | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            研究板块
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            从五个维度深入探索「淫」字的文化世界，每一个板块都是一扇通往汉字深处的窗口
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group block bg-background-50 rounded-lg p-5 md:p-6 transition-all duration-300 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 cursor-pointer"
              onMouseEnter={() => setActiveCategory(cat.slug)}
              onMouseLeave={() => setActiveCategory(null)}
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg mb-4 transition-all duration-300 ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 group-hover:bg-primary-100 group-hover:text-primary-600'
              }`}>
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-700 transition-colors duration-200">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                {cat.description}
              </p>
              <span className="text-xs text-foreground-400">
                {cat.articleCount} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}